// Comprehensive city data for SEO — targeting "sheds for sale in [city]" across America
// Each city includes SEO-optimized content for local search ranking

const stateNames = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida', GA: 'Georgia',
  HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa',
  KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
  MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri',
  MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
  NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio',
  OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
  SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
  VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming'
};

const cities = [
  // Alabama
  { name: 'Birmingham', state: 'AL', pop: 200733 },
  { name: 'Huntsville', state: 'AL', pop: 215006 },
  { name: 'Montgomery', state: 'AL', pop: 200603 },
  { name: 'Mobile', state: 'AL', pop: 187041 },
  { name: 'Tuscaloosa', state: 'AL', pop: 101129 },
  // Alaska
  { name: 'Anchorage', state: 'AK', pop: 291247 },
  { name: 'Fairbanks', state: 'AK', pop: 32325 },
  // Arizona
  { name: 'Phoenix', state: 'AZ', pop: 1608139 },
  { name: 'Tucson', state: 'AZ', pop: 542629 },
  { name: 'Mesa', state: 'AZ', pop: 504258 },
  { name: 'Scottsdale', state: 'AZ', pop: 241361 },
  { name: 'Chandler', state: 'AZ', pop: 275987 },
  { name: 'Gilbert', state: 'AZ', pop: 267918 },
  // Arkansas
  { name: 'Little Rock', state: 'AR', pop: 202591 },
  { name: 'Fort Smith', state: 'AR', pop: 89142 },
  { name: 'Fayetteville', state: 'AR', pop: 93949 },
  // California
  { name: 'Los Angeles', state: 'CA', pop: 3898747 },
  { name: 'San Diego', state: 'CA', pop: 1386932 },
  { name: 'San Jose', state: 'CA', pop: 1013240 },
  { name: 'San Francisco', state: 'CA', pop: 873965 },
  { name: 'Sacramento', state: 'CA', pop: 524943 },
  { name: 'Fresno', state: 'CA', pop: 542107 },
  { name: 'Bakersfield', state: 'CA', pop: 403455 },
  { name: 'Riverside', state: 'CA', pop: 314998 },
  // Colorado
  { name: 'Denver', state: 'CO', pop: 715522 },
  { name: 'Colorado Springs', state: 'CO', pop: 478961 },
  { name: 'Aurora', state: 'CO', pop: 386261 },
  { name: 'Fort Collins', state: 'CO', pop: 169810 },
  // Connecticut
  { name: 'Bridgeport', state: 'CT', pop: 148529 },
  { name: 'New Haven', state: 'CT', pop: 134023 },
  { name: 'Hartford', state: 'CT', pop: 121054 },
  // Delaware
  { name: 'Wilmington', state: 'DE', pop: 70898 },
  { name: 'Dover', state: 'DE', pop: 39403 },
  // Florida
  { name: 'Jacksonville', state: 'FL', pop: 949611 },
  { name: 'Miami', state: 'FL', pop: 442241 },
  { name: 'Tampa', state: 'FL', pop: 384959 },
  { name: 'Orlando', state: 'FL', pop: 307573 },
  { name: 'St. Petersburg', state: 'FL', pop: 258308 },
  { name: 'Fort Lauderdale', state: 'FL', pop: 182760 },
  { name: 'Tallahassee', state: 'FL', pop: 196169 },
  { name: 'Cape Coral', state: 'FL', pop: 194016 },
  // Georgia
  { name: 'Atlanta', state: 'GA', pop: 498715 },
  { name: 'Augusta', state: 'GA', pop: 202081 },
  { name: 'Savannah', state: 'GA', pop: 147780 },
  { name: 'Columbus', state: 'GA', pop: 206922 },
  { name: 'Macon', state: 'GA', pop: 157346 },
  // Idaho
  { name: 'Boise', state: 'ID', pop: 235684 },
  { name: 'Meridian', state: 'ID', pop: 117635 },
  { name: 'Nampa', state: 'ID', pop: 100200 },
  // Illinois
  { name: 'Chicago', state: 'IL', pop: 2693976 },
  { name: 'Aurora', state: 'IL', pop: 180542 },
  { name: 'Rockford', state: 'IL', pop: 148655 },
  { name: 'Springfield', state: 'IL', pop: 114394 },
  // Indiana
  { name: 'Indianapolis', state: 'IN', pop: 887642 },
  { name: 'Fort Wayne', state: 'IN', pop: 263886 },
  { name: 'Evansville', state: 'IN', pop: 117298 },
  { name: 'South Bend', state: 'IN', pop: 103453 },
  // Iowa
  { name: 'Des Moines', state: 'IA', pop: 214133 },
  { name: 'Cedar Rapids', state: 'IA', pop: 137710 },
  { name: 'Davenport', state: 'IA', pop: 101590 },
  // Kansas
  { name: 'Wichita', state: 'KS', pop: 397532 },
  { name: 'Overland Park', state: 'KS', pop: 197238 },
  { name: 'Kansas City', state: 'KS', pop: 156607 },
  { name: 'Topeka', state: 'KS', pop: 126587 },
  // Kentucky
  { name: 'Louisville', state: 'KY', pop: 633045 },
  { name: 'Lexington', state: 'KY', pop: 322570 },
  { name: 'Bowling Green', state: 'KY', pop: 72294 },
  // Louisiana
  { name: 'New Orleans', state: 'LA', pop: 383997 },
  { name: 'Baton Rouge', state: 'LA', pop: 227715 },
  { name: 'Shreveport', state: 'LA', pop: 187593 },
  { name: 'Lafayette', state: 'LA', pop: 121374 },
  // Maine
  { name: 'Portland', state: 'ME', pop: 68408 },
  { name: 'Lewiston', state: 'ME', pop: 37121 },
  // Maryland
  { name: 'Baltimore', state: 'MD', pop: 585708 },
  { name: 'Frederick', state: 'MD', pop: 78171 },
  { name: 'Rockville', state: 'MD', pop: 68401 },
  // Massachusetts
  { name: 'Boston', state: 'MA', pop: 675647 },
  { name: 'Worcester', state: 'MA', pop: 206518 },
  { name: 'Springfield', state: 'MA', pop: 155929 },
  // Michigan
  { name: 'Detroit', state: 'MI', pop: 639111 },
  { name: 'Grand Rapids', state: 'MI', pop: 198917 },
  { name: 'Lansing', state: 'MI', pop: 112644 },
  { name: 'Ann Arbor', state: 'MI', pop: 123851 },
  // Minnesota
  { name: 'Minneapolis', state: 'MN', pop: 429954 },
  { name: 'St. Paul', state: 'MN', pop: 311527 },
  { name: 'Rochester', state: 'MN', pop: 121395 },
  { name: 'Duluth', state: 'MN', pop: 90884 },
  // Mississippi
  { name: 'Jackson', state: 'MS', pop: 153701 },
  { name: 'Gulfport', state: 'MS', pop: 72926 },
  { name: 'Hattiesburg', state: 'MS', pop: 48602 },
  // Missouri
  { name: 'Kansas City', state: 'MO', pop: 508090 },
  { name: 'St. Louis', state: 'MO', pop: 301578 },
  { name: 'Springfield', state: 'MO', pop: 169176 },
  { name: 'Columbia', state: 'MO', pop: 126254 },
  // Montana
  { name: 'Billings', state: 'MT', pop: 119116 },
  { name: 'Missoula', state: 'MT', pop: 75516 },
  { name: 'Great Falls', state: 'MT', pop: 60442 },
  // Nebraska
  { name: 'Omaha', state: 'NE', pop: 486051 },
  { name: 'Lincoln', state: 'NE', pop: 291082 },
  // Nevada
  { name: 'Las Vegas', state: 'NV', pop: 641903 },
  { name: 'Henderson', state: 'NV', pop: 320189 },
  { name: 'Reno', state: 'NV', pop: 264165 },
  // New Hampshire
  { name: 'Manchester', state: 'NH', pop: 115644 },
  { name: 'Nashua', state: 'NH', pop: 91322 },
  // New Jersey
  { name: 'Newark', state: 'NJ', pop: 311549 },
  { name: 'Jersey City', state: 'NJ', pop: 292449 },
  { name: 'Paterson', state: 'NJ', pop: 159732 },
  // New Mexico
  { name: 'Albuquerque', state: 'NM', pop: 564559 },
  { name: 'Las Cruces', state: 'NM', pop: 111385 },
  { name: 'Santa Fe', state: 'NM', pop: 87505 },
  // New York
  { name: 'New York City', state: 'NY', pop: 8336817 },
  { name: 'Buffalo', state: 'NY', pop: 278349 },
  { name: 'Rochester', state: 'NY', pop: 211328 },
  { name: 'Syracuse', state: 'NY', pop: 148620 },
  { name: 'Albany', state: 'NY', pop: 99224 },
  // North Carolina
  { name: 'Charlotte', state: 'NC', pop: 874579 },
  { name: 'Raleigh', state: 'NC', pop: 467665 },
  { name: 'Greensboro', state: 'NC', pop: 299035 },
  { name: 'Durham', state: 'NC', pop: 283506 },
  { name: 'Winston-Salem', state: 'NC', pop: 249545 },
  { name: 'Fayetteville', state: 'NC', pop: 211657 },
  // North Dakota
  { name: 'Fargo', state: 'ND', pop: 125990 },
  { name: 'Bismarck', state: 'ND', pop: 73529 },
  // Ohio
  { name: 'Columbus', state: 'OH', pop: 905748 },
  { name: 'Cleveland', state: 'OH', pop: 372624 },
  { name: 'Cincinnati', state: 'OH', pop: 309317 },
  { name: 'Toledo', state: 'OH', pop: 270871 },
  { name: 'Akron', state: 'OH', pop: 190469 },
  { name: 'Dayton', state: 'OH', pop: 137644 },
  // Oklahoma
  { name: 'Oklahoma City', state: 'OK', pop: 681054 },
  { name: 'Tulsa', state: 'OK', pop: 413066 },
  { name: 'Norman', state: 'OK', pop: 128026 },
  // Oregon
  { name: 'Portland', state: 'OR', pop: 652503 },
  { name: 'Salem', state: 'OR', pop: 175535 },
  { name: 'Eugene', state: 'OR', pop: 176654 },
  { name: 'Bend', state: 'OR', pop: 99178 },
  // Pennsylvania
  { name: 'Philadelphia', state: 'PA', pop: 1603797 },
  { name: 'Pittsburgh', state: 'PA', pop: 302971 },
  { name: 'Allentown', state: 'PA', pop: 126092 },
  { name: 'Erie', state: 'PA', pop: 94831 },
  // Rhode Island
  { name: 'Providence', state: 'RI', pop: 190934 },
  { name: 'Warwick', state: 'RI', pop: 82823 },
  // South Carolina
  { name: 'Charleston', state: 'SC', pop: 150227 },
  { name: 'Columbia', state: 'SC', pop: 137541 },
  { name: 'Greenville', state: 'SC', pop: 72095 },
  { name: 'Myrtle Beach', state: 'SC', pop: 35682 },
  // South Dakota
  { name: 'Sioux Falls', state: 'SD', pop: 192517 },
  { name: 'Rapid City', state: 'SD', pop: 77503 },
  // Tennessee
  { name: 'Nashville', state: 'TN', pop: 689447 },
  { name: 'Memphis', state: 'TN', pop: 633104 },
  { name: 'Knoxville', state: 'TN', pop: 190740 },
  { name: 'Chattanooga', state: 'TN', pop: 181099 },
  { name: 'Clarksville', state: 'TN', pop: 166722 },
  // Texas
  { name: 'Houston', state: 'TX', pop: 2304580 },
  { name: 'San Antonio', state: 'TX', pop: 1547253 },
  { name: 'Dallas', state: 'TX', pop: 1304379 },
  { name: 'Austin', state: 'TX', pop: 978908 },
  { name: 'Fort Worth', state: 'TX', pop: 918915 },
  { name: 'El Paso', state: 'TX', pop: 678815 },
  { name: 'Arlington', state: 'TX', pop: 394266 },
  { name: 'Corpus Christi', state: 'TX', pop: 317863 },
  { name: 'Plano', state: 'TX', pop: 285494 },
  { name: 'Lubbock', state: 'TX', pop: 263648 },
  { name: 'Laredo', state: 'TX', pop: 255205 },
  { name: 'Amarillo', state: 'TX', pop: 200393 },
  { name: 'Midland', state: 'TX', pop: 146038 },
  { name: 'Waco', state: 'TX', pop: 139236 },
  { name: 'Tyler', state: 'TX', pop: 107405 },
  // Utah
  { name: 'Salt Lake City', state: 'UT', pop: 199723 },
  { name: 'West Valley City', state: 'UT', pop: 140230 },
  { name: 'Provo', state: 'UT', pop: 115162 },
  { name: 'St. George', state: 'UT', pop: 95342 },
  // Vermont
  { name: 'Burlington', state: 'VT', pop: 44743 },
  // Virginia
  { name: 'Virginia Beach', state: 'VA', pop: 459470 },
  { name: 'Norfolk', state: 'VA', pop: 238005 },
  { name: 'Richmond', state: 'VA', pop: 226610 },
  { name: 'Chesapeake', state: 'VA', pop: 249422 },
  // Washington
  { name: 'Seattle', state: 'WA', pop: 737015 },
  { name: 'Spokane', state: 'WA', pop: 228989 },
  { name: 'Tacoma', state: 'WA', pop: 219346 },
  { name: 'Vancouver', state: 'WA', pop: 190915 },
  // West Virginia
  { name: 'Charleston', state: 'WV', pop: 48006 },
  { name: 'Huntington', state: 'WV', pop: 46842 },
  // Wisconsin
  { name: 'Milwaukee', state: 'WI', pop: 577222 },
  { name: 'Madison', state: 'WI', pop: 269840 },
  { name: 'Green Bay', state: 'WI', pop: 107395 },
  // Wyoming
  { name: 'Cheyenne', state: 'WY', pop: 65132 },
  { name: 'Casper', state: 'WY', pop: 58610 },
];

// Generate slug from city name + state
const generateSlug = (name, state) => {
  return `${name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}-${state.toLowerCase()}`;
};

// Build the full city data map
export const cityDataMap = {};
cities.forEach(city => {
  const slug = generateSlug(city.name, city.state);
  cityDataMap[slug] = {
    name: city.name,
    state: city.state,
    stateName: stateNames[city.state],
    full: `${city.name}, ${stateNames[city.state]}`,
    slug,
    pop: city.pop
  };
});

// Get all cities grouped by state
export const citiesByState = {};
cities.forEach(city => {
  if (!citiesByState[city.state]) {
    citiesByState[city.state] = [];
  }
  citiesByState[city.state].push({
    ...city,
    slug: generateSlug(city.name, city.state),
    stateName: stateNames[city.state],
    full: `${city.name}, ${stateNames[city.state]}`
  });
});

// Get nearby cities for internal linking (same state first, then nearby states)
const nearbyStateMap = {
  AL: ['GA', 'FL', 'TN', 'MS'], AK: [], AZ: ['NM', 'NV', 'CA', 'UT'],
  AR: ['TX', 'LA', 'MO', 'OK'], CA: ['AZ', 'NV', 'OR'], CO: ['WY', 'NM', 'KS', 'UT'],
  CT: ['NY', 'MA', 'RI'], DE: ['MD', 'PA', 'NJ'], FL: ['GA', 'AL', 'SC'],
  GA: ['FL', 'SC', 'AL', 'TN', 'NC'], HI: [], ID: ['WA', 'OR', 'MT', 'UT'],
  IL: ['IN', 'WI', 'MO', 'IA'], IN: ['IL', 'OH', 'KY', 'MI'], IA: ['NE', 'MN', 'IL', 'MO'],
  KS: ['MO', 'NE', 'OK', 'CO'], KY: ['TN', 'IN', 'OH', 'VA'], LA: ['TX', 'MS', 'AR'],
  ME: ['NH', 'MA', 'VT'], MD: ['VA', 'PA', 'DE'], MA: ['CT', 'NH', 'NY', 'RI'],
  MI: ['IN', 'OH', 'WI'], MN: ['WI', 'IA', 'ND', 'SD'], MS: ['AL', 'LA', 'TN'],
  MO: ['KS', 'IL', 'AR', 'OK'], MT: ['ND', 'SD', 'WY', 'ID'], NE: ['KS', 'IA', 'SD', 'CO'],
  NV: ['CA', 'AZ', 'UT'], NH: ['ME', 'MA', 'VT'], NJ: ['NY', 'PA', 'DE'],
  NM: ['TX', 'AZ', 'CO'], NY: ['NJ', 'CT', 'PA', 'MA'], NC: ['SC', 'VA', 'TN', 'GA'],
  ND: ['SD', 'MN', 'MT'], OH: ['IN', 'KY', 'PA', 'MI'], OK: ['TX', 'KS', 'AR', 'MO'],
  OR: ['WA', 'CA', 'ID'], PA: ['NJ', 'NY', 'OH', 'MD'], RI: ['MA', 'CT'],
  SC: ['NC', 'GA'], SD: ['ND', 'NE', 'MN'], TN: ['KY', 'GA', 'AL', 'NC', 'VA'],
  TX: ['OK', 'LA', 'NM', 'AR'], UT: ['CO', 'NV', 'AZ', 'ID'], VT: ['NH', 'NY', 'MA'],
  VA: ['NC', 'MD', 'KY', 'TN'], WA: ['OR', 'ID'], WV: ['VA', 'KY', 'OH', 'PA'],
  WI: ['MN', 'IL', 'MI', 'IA'], WY: ['MT', 'CO', 'SD', 'ID']
};

export const getNearbyCities = (citySlug, limit = 8) => {
  const city = cityDataMap[citySlug];
  if (!city) return Object.values(cityDataMap).slice(0, limit);

  const sameState = Object.values(cityDataMap)
    .filter(c => c.state === city.state && c.slug !== citySlug);

  const nearbyStates = nearbyStateMap[city.state] || [];
  const nearby = Object.values(cityDataMap)
    .filter(c => nearbyStates.includes(c.state));

  return [...sameState, ...nearby].slice(0, limit);
};

// Get all state slugs for sitemap
export const getAllStates = () => {
  return Object.entries(stateNames).map(([code, name]) => ({
    code,
    name,
    slug: name.toLowerCase().replace(/\s+/g, '-'),
    cityCount: (citiesByState[code] || []).length
  })).filter(s => s.cityCount > 0);
};

// Get all city slugs for sitemap
export const getAllCitySlugs = () => Object.keys(cityDataMap);

export { stateNames };
export default cityDataMap;
